<template>
  <div id="app" ref="app" :class="{'hasHeader': !includeShow}">
      <router-view></router-view>
  </div>
</template>

<script>
    // import { secretCookie } from '@/utils/utils'
     import { mapGetters, mapMutations } from 'vuex'
        export default {
        name: 'App',
        data(){
            return {
                loadingFlag: true
            }
        },
        mounted() {
            /*setTimeout(() => {
                  document.getElementById("loading").style.display = 'none';
            }, 1000)*/
            // secretCookie()
        },
        computed: mapGetters({
          'includeShow': 'includeShow'
        }),
    }
</script>

<style scoped type="text/less" lang="less">
    #app{
        position: relative;
        min-height: 600px;
        padding-top: 110px;
        padding-bottom: 287px;
    }
    #app.hasHeader{
        min-height: 0;
        padding-top:0;
        padding-bottom: 0;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue